import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// helpers
import get from 'lodash.get';

function PdpSharedDetailWear({ item }) {
    const wearDisplay = get(item, 'condition.wearDisplay');
    if (!wearDisplay) {
        return null;
    }
    return <span data-tn="pdp-spec-wear">{wearDisplay}</span>;
}

PdpSharedDetailWear.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailWear, {
    item: graphql`
        fragment PdpSharedDetailWear_item on Item {
            condition {
                wearDisplay
            }
        }
    `,
});
